// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SectionInfo_wrapper__3Mlxo","spin":"SectionInfo_spin__2c7Za","transition-opacity":"SectionInfo_transition-opacity__17pas"};